"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldValue = void 0;
class FormFieldValue {
    constructor(fieldId = 0, value = "", values = []) {
        this.fieldId = fieldId;
        this.value = value;
        this.values = values;
    }
    static fromDto(dto) {
        var _a, _b;
        return new FormFieldValue(dto.fieldId, (_a = dto.value) !== null && _a !== void 0 ? _a : "", (_b = dto.values) !== null && _b !== void 0 ? _b : []);
    }
    toDto() {
        return {
            fieldId: this.fieldId,
            value: this.value,
            values: this.values,
        };
    }
    copy() {
        return new FormFieldValue(this.fieldId, this.value, this.values);
    }
    get isMultiValue() {
        return this.values.length > 0;
    }
}
exports.FormFieldValue = FormFieldValue;
